import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import config from "../../../config";
import { showToast } from "../../../utils/toast";

export default function ItemModal({
  show,
  onClose,
  categories,
  refresh,
  editData
}) {
  const [formData, setFormData] = useState({
    category_id: "",
    item_name: "",
    item_code: "",
    quantity: 0,
    minimum_quantity: 5,
    unit: "",
    location: "",
    item_type: "Consumable",
    remarks: ""
  });

  useEffect(() => {
    if (editData) {
      setFormData({
        ...editData
      });
    }
  }, [editData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    if (!formData.item_name.trim() || !formData.category_id) {
      showToast("warning", "Item name and category are required");
      return;
    }

    try {
      let res;

      if (editData) {
        res = await axios.put(
          `${config.apiBaseUrl}/inventory/update-item.php`,
          formData
        );
      } else {
        res = await axios.post(
          `${config.apiBaseUrl}/inventory/create-item.php`,
          formData
        );
      }

      if (res.data.success) {
        showToast("success", res.data.message);
        refresh();
        onClose();
      }

    } catch (error) {
      showToast("error", "Operation failed");
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {editData ? "Edit Item" : "Add New Item"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Category</Form.Label>
                <Form.Select
                  name="category_id"
                  value={formData.category_id}
                  onChange={handleChange}
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option
                      key={cat.category_id}
                      value={cat.category_id}
                    >
                      {cat.category_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Item Name</Form.Label>
                <Form.Control
                  type="text"
                  name="item_name"
                  value={formData.item_name}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Item Code</Form.Label>
                <Form.Control
                  type="text"
                  name="item_code"
                  value={formData.item_code}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Quantity</Form.Label>
                <Form.Control
                  type="number"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Minimum Quantity</Form.Label>
                <Form.Control
                  type="number"
                  name="minimum_quantity"
                  value={formData.minimum_quantity}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Unit</Form.Label>
                <Form.Control
                  type="text"
                  name="unit"
                  placeholder="pcs, kg, box..."
                  value={formData.unit}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Item Type</Form.Label>
                <Form.Select
                  name="item_type"
                  value={formData.item_type}
                  onChange={handleChange}
                >
                  <option value="Consumable">Consumable</option>
                  <option value="Reusable">Reusable</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group>
            <Form.Label>Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {editData ? "Update Item" : "Save Item"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}